import React, { Component } from "react";
import Checkbox from "material-ui/Checkbox";
import ActionThumbUp from "material-ui/svg-icons/action/thumb-up";
import AvAlbum from "material-ui/svg-icons/av/album";
// import Sky from "react-sky";
// import icon2 from "./icon2.png";
// import icon3 from "./icon3.png";
// import icon4 from "./icon4.png";
import "./awards.css";

class DesignComponent extends Component {
  render() {
    return (
      <div className="design">
        {/* <Sky
          images={{
            
            0: icon2,
            1: icon3,
            2: icon4
          }}
          how={
            130
          } 
          time={40} 
          size={"100px"} 
          background={"palettedvioletred"} 
        /> */}
        <p className="headline">Awards and Achievements</p>

        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="INFORMATION TECHNOLOGY INTERNATIONAL MERIT SCHOLARSHIP (2017-2019)"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="SUMMER RESEARCH SCHOLARSHIP - MITI PROGRAM (2018-2019)"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Served as a Faculty of IT tutor for Python Programming Bootcamp 2018 and 2019 at Monash University"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Participant in Melbourne Business Analytics Datathon 2018, Melbourne Business School"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Participant in Melbourne Datathon 2018"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Participant in Grad Hack 2018 Amazon Web Services (AWS)"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Awarded UNIHACK Diversity Scholarship 2019"
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="UNIHACK 2019 3rd Prize Winner for iValuate. An app to help students practice video interviews and get real-
time feedback and to help potential youtubers and people to improve their public speaking skills."
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Received an award for Best Start-up Potential idea at UNIHACK 2019."
          />
        </div>
        <div className="design-checkbox">
          <Checkbox
            checkedIcon={<ActionThumbUp />}
            uncheckedIcon={<AvAlbum />}
            iconStyle={{ fill: "#A80202" }}
            label="Participant in Wade Institute StartUp Sprint 2019, Ormond College, University of Melbourne."
          />
        </div>
      </div>
    );
  }
}

export default DesignComponent;
